import Icon from 'components/atoms/Icon';
import dayjs from 'dayjs';
import { useRef, useState } from 'react';
import { Pressable, StyleSheet, View } from 'react-native';
import DateTimePicker, { useDefaultStyles } from 'react-native-ui-datepicker';
import { ThemedValues } from 'styles/themed';
import DatepickerStyles, { DatepickerContainerStyles } from 'theme/Datepicker/DatepickerStyles';
import Modal from 'theme/Modal';
import Text from 'theme/Text';
import { colorList } from 'utils/colors';
import { IconSystemConstants } from 'utils/constants/IconNameConstants';
import HelperLocale from 'utils/helper-locale';

const DatepickerRange = ({ value, onSelect = undefined, min, max }) => {

    const clicks = useRef(0);
    const [ startDate, setStartDate ] = useState( value ? value[0] : undefined );
    const [ endDate, setEndDate ] = useState( value ? value[1] : undefined );

    const [ show, setShow ] = useState(false);

    const defaultStyles = useDefaultStyles();

    const onChange = ({startDate, endDate}) => {
        clicks.current++;

        // Check if clicks is even
        if( startDate && clicks.current % 2 === 1 ) {
            setStartDate(startDate);
        }

        // Check if clicks is odd
        if( endDate && clicks.current % 2 === 0 ) {
            setEndDate(endDate);
        }

        if (startDate && endDate) {
            if( onSelect ) {
                onSelect( [ startDate, endDate ] );
            }

            setShow( false );
        }
    };

    const onPressShow = () => {
        // reset the clicks counter
        clicks.current = 0;

        setStartDate( undefined );
        setEndDate( undefined );

        setShow( true );
    }

    return (
        <Pressable 
            onPress={ onPressShow }>
            
            <View
                style={styles.container}>

                <Text 
                    style={styles.inputText}>
                    
                    { dayjs( startDate ).format('YYYY-MM-DD') } - { dayjs( endDate ).format('YYYY-MM-DD') }
                </Text>

                <Icon 
                    icon={ IconSystemConstants.CALENDAR } 
                    color={ colorList.TEXT.primary }
                />
            </View>
                
            <Modal
                visible={ show }
                onClose={ setShow.bind( this, false ) }
                headerStyle={ DatepickerContainerStyles.headerStyle }
                modalStyle={ DatepickerContainerStyles.modalStyle }
                closeStyle={ DatepickerContainerStyles.closeStyle }>
                
                <DateTimePicker
                    mode="range"
                    initialView="day"
                    locale={ HelperLocale.localeSubstr( HelperLocale.getDeviceLocale() ) }
                    firstDayOfWeek={1}
                    onChange={ onChange}
                    min={ min }
                    max={ max }
                    startDate={ startDate }
                    endDate={ endDate }
                    containerStyle={ DatepickerContainerStyles.picker }
                    style={ DatepickerContainerStyles.picker }
                    styles={{
                        ...defaultStyles,
                        ...DatepickerStyles,
                    }}
                />
            </Modal>
        </Pressable>
    )
}

const styles = StyleSheet.create({
    container: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: 10,
        borderColor: colorList.GREY.primary,
        borderWidth: 1,
        borderRadius: ThemedValues.borderRadius,
        backgroundColor: colorList.WHITE.primary,
    },

    inputText: {
        fontSize: ThemedValues.fontSize,
        color: colorList.TEXT.primary,
    },
})

export default DatepickerRange;